import { Loader } from "@googlemaps/js-api-loader";

const map_key = estatetool_gmaps
  ? estatetool_gmaps.api_key
  : "AIzaSyB4XG4gn365aWHQ0fpZrNKF1flAI5okQjs";

const googleMapLoader = new Loader({
  apiKey: map_key,
  version: "weekly",
});

export default googleMapLoader;
